/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMRegisterBeginEvent } from '@/data/events/handlers/gtm/RegisterBegin';
import { GTMRegisterBeginPayload } from '@/data/types/GTM';

type RegisterBeginDelegatorProps = {
	gtm?: GTMRegisterBeginPayload;
};

export const registerBeginDelegator = async (payload: RegisterBeginDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMRegisterBeginEvent(gtm);
	}
};
